import { Component, Input, OnChanges, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ExtratoDeRecebimentos } from '../../../pkw-data/collect/extrato/extrato-de-recebimentos.model'
import { ExtratoDeVendas } from '../../../pkw-data/collect/extrato/extrato-de-vendas.model'
import { Empresa } from '../../../pkw-data/core/empresa.model'
import { ExtratoDeRecebimentosService } from '../../extratos-de-recebimentos/shared/extrato-de-recebimentos.service'
import { ExtratoDeVendasService } from '../../extratos-de-vendas/shared/extrato-de-vendas.service'
import { DadosIniciaisExtratos } from '../../shared/dados-iniciais-extratos'
import { FiltroExtrato } from '../../shared/filtro-extrato'
import { ChartRecebimentosOptions } from './shared/chart-recebimentos-options'
import { ChartVendasOptions } from './shared/chart-vendas-options'

@Component({
    selector: 'col-vendas-recebimentos',
    templateUrl: './vendas-recebimentos.component.html',
    styleUrls: ['../dashboard-extratos.component.scss']
})
export class VendasRecebimentosComponent implements OnInit, OnChanges {
    static periodos = {
        mesAtual: 'Mês',
        mesAnterior: 'Mês anterior'
    }

    @Input() empresa: Empresa

    periodo: string
    periodos = VendasRecebimentosComponent.periodos
    chartVendasOptions: ChartVendasOptions
    chartRecebimentosOptions: ChartRecebimentosOptions
    totalVendido: number
    totalRecebido: number

    private iniciado: boolean

    static obterFiltro(periodo: string, empresa: Empresa) {
        const agora = new Date()
        let inicio: Date
        let fim: Date

        switch (periodo) {
            case VendasRecebimentosComponent.periodos.mesAtual:
                inicio = new Date(agora.getFullYear(), agora.getMonth())
                fim = new Date(agora.getFullYear(), agora.getMonth() + 1, 0)
                break
            case VendasRecebimentosComponent.periodos.mesAnterior:
                inicio = new Date(agora.getFullYear(), agora.getMonth() - 1)
                fim = new Date(agora.getFullYear(), agora.getMonth(), 0)
                break
        }

        return new FiltroExtrato(inicio, fim, empresa)
    }

    constructor(
        private route: ActivatedRoute,
        private extratoDeVendasService: ExtratoDeVendasService,
        private extratoDeRecebimentosService: ExtratoDeRecebimentosService
    ) {
        this.periodo = VendasRecebimentosComponent.periodos.mesAtual
        this.iniciado = false
    }

    ngOnInit() {
        this.route.data.subscribe(
            ({ dadosIniciais }: { dadosIniciais: DadosIniciaisExtratos }) => {
                this.calcularTotalVendido(dadosIniciais.vendasMesAtual)
                this.calcularTotalRecebido(dadosIniciais.recebimentosMesAtual)
                this.chartVendasOptions = new ChartVendasOptions(
                    dadosIniciais.vendasMesAtual,
                    this.periodo
                )
                this.chartRecebimentosOptions = new ChartRecebimentosOptions(
                    dadosIniciais.recebimentosMesAtual,
                    this.periodo
                )
                this.iniciado = true
            }
        )
    }

    ngOnChanges() {
        if (this.empresa && this.iniciado) {
            this.atualizarCharts()
        }
    }

    setPeriodo(periodo: string) {
        this.periodo = periodo
        this.atualizarCharts()
    }

    atualizarCharts() {
        this.obterDadosVendas()
        this.obterDadosRecebimentos()
    }

    private obterDadosVendas() {
        const filtro = this.obterFiltro()

        this.extratoDeVendasService
            .pesquisar(filtro.toFilter())
            .subscribe(extratosDeVendas => {
                const extrato = extratosDeVendas[0]

                this.calcularTotalVendido(extrato)
                this.chartVendasOptions = new ChartVendasOptions(extrato, this.periodo)
            })
    }

    private obterDadosRecebimentos() {
        const filtro = this.obterFiltro()

        this.extratoDeRecebimentosService
            .pesquisar(filtro.toFilter())
            .subscribe(extratosDeRecebimentos => {
                const extrato = extratosDeRecebimentos[0]

                this.calcularTotalRecebido(extrato)
                this.chartRecebimentosOptions = new ChartRecebimentosOptions(
                    extrato,
                    this.periodo
                )
            })
    }

    private calcularTotalVendido(extrato: ExtratoDeVendas) {
        if (extrato) {
            this.totalVendido = extrato.agrupamentos.reduce((total, agrupamento) => {
                return total + agrupamento.transacao.valorBruto
            }, 0)
        } else {
            this.totalVendido = 0
        }
    }

    private calcularTotalRecebido(extrato: ExtratoDeRecebimentos) {
        if (extrato) {
            this.totalRecebido = extrato.agrupamentos.reduce((total, agrupamento) => {
                return total + agrupamento.transacao.valorLiquido
            }, 0)
        } else {
            this.totalRecebido = 0
        }
    }

    private obterFiltro() {
        return VendasRecebimentosComponent.obterFiltro(this.periodo, this.empresa)
    }
}



// WEBPACK FOOTER //
// ./src/app/extratos/dashboard-extratos/vendas-recebimentos/vendas-recebimentos.component.ts